import {TypedValueObject} from "@icure/api";

export const DESKTOP_API_CREDENTIALS_PROP = 'be.medispring.desktopApi';

export interface UserInfo{
  groupId: string;
  groupPassword: string;
  userId: string;
  creationDate?: Date;
  creationDateHr?: string;
  name?: string;
  login?: string;
  isKeyGenerate?: boolean;
  nihii?: string;
  ssin?: string;
  adr?: {
    street: string;
    houseNumber: string;
    postalCode: string;
    city: string;
    country: string;
    region?: string;
  },
  steps?: {
    step_1: boolean;
    step_2: boolean;
    step_3: boolean;
    step_4: boolean;
    step_5: boolean;
  }
  speciality?: string;
  statusHr?: string;
  userName?: string;
  language?: string;
  convention?: string;
  defaultTarification?: string;
}

export interface LicenceInfos{
  startDate: string;
  endDate: string;
  licenceType: string;
}

export interface AssistantInfos{
  validationDate: string;
  isNextStructureTheSame: boolean;
  nextStatus: string;
  nextSupervisorId: string;
}

export const PropertyParser = {
  [TypedValueObject.TypeEnum.BOOLEAN]: (v: TypedValueObject) => v.booleanValue,
  [TypedValueObject.TypeEnum.INTEGER]: (v: TypedValueObject) => v.integerValue,
  [TypedValueObject.TypeEnum.DOUBLE]: (v: TypedValueObject) => v.doubleValue,
  [TypedValueObject.TypeEnum.DATE]: (v: TypedValueObject) => v.dateValue,
  [TypedValueObject.TypeEnum.STRING]: (v: TypedValueObject) => v.stringValue,
  [TypedValueObject.TypeEnum.JSON]: (v: TypedValueObject) => {
    try {
      return JSON.parse(v?.stringValue!!);
    } catch (e) {
      return null;
    }
  },
};
